import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isDark, isWhite, shadeColor } from 'common-logic';
import { TrackingInfo } from '@evermile/customer-tracking';
import CustomerTrackingStatusEnum = TrackingInfo.CustomerTrackingStatusEnum;

interface GiftColors {
  // cube
  frontCubeFaceColor: string;
  sideCubeFaceColor: string;
  topCubeFaceColor: string;
  // ribbon
  frontRibbonColor: string;
  sideRibbonColor: string;
  topRibbonColor: string;
  // bow
  bowColor: string;
  bowInnerColor: string;
  bowTieColor: string;
  // sparkles
  sparklesColor?: string;
  // on its way arrow
  arrowColor?: string;
  // delivered check
  checkBackgroundColor?: string;
}

const defaultColors = {
  // cube
  frontCubeFaceColor: '#FCCCA0',
  sideCubeFaceColor: '#EDB17A',
  topCubeFaceColor: '#FFDDBE',
  // ribbon
  frontRibbonColor: '#FE8B72',
  sideRibbonColor: '#FE8B72',
  topRibbonColor: '#FF9E89',
  // bow
  bowColor: '#FE8B72',
  bowInnerColor: '#D2654D',
  bowTieColor: '#FF9E89',
};

@Component({
  selector: 'common-gift-colored-icon',
  templateUrl: './gift-colored-icon.component.html',
  styleUrls: ['./gift-colored-icon.component.scss'],
})
export class GiftColoredIconComponent implements OnChanges {
  @Input({ required: true }) baseColor!: string;
  @Input({ required: true }) orderStatus!: CustomerTrackingStatusEnum;

  colors: GiftColors = defaultColors;

  ngOnChanges(changes: SimpleChanges) {
    if (isWhite(this.baseColor)) {
      this.colors = defaultColors;
    } else if (isDark(this.baseColor)) {
      this.colors = {
        frontCubeFaceColor: shadeColor(this.baseColor, 40),
        sideCubeFaceColor: shadeColor(this.baseColor, 20),
        topCubeFaceColor: shadeColor(this.baseColor, 60),
        frontRibbonColor: shadeColor(this.baseColor, 70),
        sideRibbonColor: shadeColor(this.baseColor, 65),
        topRibbonColor: shadeColor(this.baseColor, 80),
        bowColor: shadeColor(this.baseColor, 70),
        bowInnerColor: shadeColor(this.baseColor, 40),
        bowTieColor: shadeColor(this.baseColor, 80),
        sparklesColor: '#FFF',
        checkBackgroundColor: '#FFF',
      };
    } else {
      this.colors = {
        frontCubeFaceColor: shadeColor(this.baseColor, -20),
        sideCubeFaceColor: shadeColor(this.baseColor, -30),
        topCubeFaceColor: shadeColor(this.baseColor, -10),
        frontRibbonColor: shadeColor(this.baseColor, -40),
        sideRibbonColor: shadeColor(this.baseColor, -65),
        topRibbonColor: shadeColor(this.baseColor, -30),
        bowColor: shadeColor(this.baseColor, -40),
        bowInnerColor: shadeColor(this.baseColor, -60),
        bowTieColor: shadeColor(this.baseColor, -30),
        sparklesColor: '#343E57',
        checkBackgroundColor: '#343E57',
      };
    }
  }

  protected readonly CustomerTrackingStatusEnum = CustomerTrackingStatusEnum;
}
